package com.xtream.ui.ui.widget

import androidx.compose.animation.core.LinearOutSlowInEasing
import androidx.compose.animation.core.animateFloatAsState
import androidx.compose.animation.core.tween
import androidx.compose.foundation.lazy.LazyListState
import androidx.compose.runtime.Composable
import androidx.compose.runtime.State
import androidx.compose.runtime.derivedStateOf
import androidx.compose.runtime.getValue
import androidx.compose.runtime.remember

@Composable
fun LazyListState.rememberItemAlpha(
    index: Int,
    offsetThreshold: Int = 0,
    minAlpha: Float = 0.1f
): State<Float> {
    return remember(this, index, offsetThreshold, minAlpha) {
        derivedStateOf {
            val info = layoutInfo.visibleItemsInfo.firstOrNull { it.index == index }

            if (info != null) {
                if (info.offset >= offsetThreshold) 1f else minAlpha
            } else {
                // If it's not in visibleItemsInfo, check if it's "before" the visible range
                val firstVisible = layoutInfo.visibleItemsInfo.firstOrNull()?.index ?: 0
                if (index < firstVisible) minAlpha else 1f
            }
        }
    }
}

@Composable
fun LazyListState.rememberAnimatedItemAlpha(
    index: Int,
    offsetThreshold: Int = 0,
    minAlpha: Float = 0.3f
): State<Float> {
    // 1. Get the "target" alpha (snappy)
    val targetAlpha by remember(this, index, offsetThreshold, minAlpha) {
        derivedStateOf {
            val visibleItems = layoutInfo.visibleItemsInfo
            val info = visibleItems.firstOrNull { it.index == index }

            if (info != null) {
                if (info.offset >= offsetThreshold) 1f else minAlpha
            } else {
                // If not visible, check if it's behind the first visible item
                val firstVisible = visibleItems.firstOrNull()?.index ?: 0
                if (index < firstVisible) minAlpha else 1f
            }
        }
    }

    // 2. Animate the movement toward that target
    return animateFloatAsState(
        targetValue = targetAlpha,
        animationSpec = tween(durationMillis = 150, easing = LinearOutSlowInEasing),
        label = "ItemAlphaAnimation"
    )
}